import { render, staticRenderFns } from "./table.order.component.vue?vue&type=template&id=f403e65e&scoped=true"
import script from "./table.order.component.vue?vue&type=script&lang=js"
export * from "./table.order.component.vue?vue&type=script&lang=js"
import style0 from "./table.order.component.vue?vue&type=style&index=0&id=f403e65e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f403e65e",
  null
  
)

export default component.exports